export enum UserState {
    Created = 'Created',
    Active = 'Active',
    Inactive = 'Inactive',
    Disabled = 'Disabled',
    Deleted = 'Deleted',
    EMPTY = '', // TODO the dev database contains empty states...
}
